import React, { Component } from 'react';
import { Grid, withStyles } from '@material-ui/core';
import Topbar from '../common/Topbar';
import Footer from '../common/Footer';

const styles = (theme) => ({
  bg: {
    width: '100%',
    // height: 'calc(100vh - 85px)',
    overflowX: 'hidden',
    overflowY: 'auto',
    backgroundColor: '#fafafa',
  },
  bg_ceo_msg: {
    color: '#555555',
    backgroundColor: '#ffffff',
    margin: '8vh 0',
    backgroundImage: `url('/images/bg_ceo_msg_new.jpg')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    backgroundPosition: '100% 0%',
    borderRadius: '20px',
  },
  ceoMsgInnerGrid: {
    // padding: this.state.matches ? '8vh 6vw 30vh 6vw' : '4vh 6vw 30vh 6vw',
    // marginBottom: this.state.matches ? '0vh' : '40vh',

    textAlign: 'center',
    padding: '85% 17vw 10vh',
    // marginBottom: '40vh',
    [theme.breakpoints.down('lg')]: {
      // marginBottom: '50vh',
    },
    [theme.breakpoints.down('md')]: {
      // marginBottom: '20vh',
    },
    [theme.breakpoints.down('sm')]: {
      // padding: '8vh 6vw 30vh 6vw',
      padding: '85% 5vw 10vh',
    },
    [theme.breakpoints.down('xs')]: {
      // padding: '8vh 6vw 30vh 6vw',
    },
    ['@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)']: {
      // marginBottom: '50vh',
      [theme.breakpoints.down('lg')]: {
        // marginBottom: '70vh',
      },
    },
  },
});

class CeoIntro extends Component {
  constructor(props) {
    super(props);
    this.state = { matches: window.matchMedia('(max-width:600px)').matches };
  }
  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Topbar />
        <div className={classes.bg}>
          <Grid id="Positioning_grid" container justify="center" style={{ padding: '0 30px', wordBreak: 'keep-all' }}>
            <Grid
              container
              justify="flex-start"
              style={{
                padding: this.state.matches ? '2vh calc(2vw - 30px)' : '2vh calc(2vw - 30px) 0',
                color: '#1b1d54',
                fontSize: '1.3em',
              }}
            >
              <b>회사소개 〉 CEO 메세지</b>
            </Grid>
            <Grid id="content_grid" container justify="center" item xs={12}>
              <Grid id="content_grid" className={classes.bg_ceo_msg}>
                <Grid
                  className={classes.ceoMsgInnerGrid}
                  style={{ fontSize: this.state.matches ? '1em' : '1.1em', lineHeight: this.state.matches ? 1.5 : 1.7 }}
                >
                  안녕하십니까?
                  <br />
                  <span style={{ fontSize: 'large' }}>
                    (주)두원시스템 <b>대표이사 오영두</b>입니다.
                  </span>
                  <br />
                  <br />
                  <br />
                  <span style={{ color: '#f05454', fontWeight: 'bold' }}>두원 스탬프투어 통합솔루션의 탄생</span>
                  <br />
                  <br />
                  자연과 함께하는 시간을 많이 보냈던 저는…
                  <br />
                  지방 곳곳의 둘레길이며 관광지를 둘러보며
                  <br />
                  기존 스탬프투어를 하는 모든 곳에 <br />
                  민원이 생길만한 문제가 너무 많다는 것을
                  <br /> 알게 되었습니다. <br />
                  사용자 누구나 기분 좋게 깔끔한 <br />
                  스탬프함에서 산뜻한 날인을 할 수 있고
                  <br /> 관리자 누구나 보다 쉽고 편리하게
                  <br /> 관리할 수 있는 방법을 <br />
                  연구해야겠다고 생각 했습니다.
                  <br />
                  <br />
                  <br />
                  <span style={{ color: '#f05454', fontWeight: 'bold' }}>두원 스탬프투어 통합솔루션의 발전</span>
                  <br />
                  <br />
                  전국 방방곡곡을 찾아다니며 <br />
                  기존 스탬프투어의 문제점들을 <br />
                  일일이 찾아 분석하고 하나씩 하나씩
                  <br /> 해결할 방법을 연구개발 해 나갔습니다. <br />
                  그 결과, 국내 최초로 <br />
                  "보안형 고정 원터치식 스탬핑 유닛과
                  <br /> 인증 스탬핑 유닛"을 비롯하여
                  <br /> 지속적으로 수많은 특허를 출원중에 있고
                  <br /> 이를 계기로 각 지자체 및 대상처,
                  <br /> 관계부처로부터 인정을 받고 있습니다. <br />
                  급기야, 2018년도에는 국내 최초로
                  <br /> "스탬프투어 통합솔루션 관광벤처기업"으로
                  <br /> 선정되어 그간 수많은 지차체 및 대상처에
                  <br />
                  스탬프투어 통합솔루션을 성공적으로
                  <br /> 정착시켜 드리고 있습니다.
                  <br />
                  최근에는 온오프라인 스탬프투어의
                  <br /> 장점을 융합시킨
                  <br /> "스마트 스탬프투어 웹 통합솔루션"이라는 <br />
                  새로운 플랫폼 서비스 체계를 구축하였고,
                  <br /> 관광객 및 사용자는 물론,
                  <br /> 각 지자체 및 대상처에 혁신적인
                  <br /> "스마트 관광 솔루션"으로
                  <br /> 성장하게 될 것입니다.
                  <br />
                  <br />
                  <br />
                  <span style={{ color: '#f05454', fontWeight: 'bold' }}>맺음말</span>
                  <br />
                  <br />
                  <span style={{ color: '#f05454', fontWeight: 'bold' }}>㈜두원시스템은 "꿈과 희망"이 있습니다.</span>
                  <br />
                  <br />전 임직원 모두가 혼연일체가 되어
                  <br /> 목표를 향해 부단히 노력하고,
                  <br /> 항상 새로운것에 도전하는
                  <br /> 적극적인 자세를 보면 희망찬 앞날이 보입니다. <br />
                  이제, ㈜두원시스템은 명실공히
                  <br /> "대한민국 스마트 스탬프투어
                  <br /> 웹 통합솔루션의 대표주자"로써 <br />
                  대한민국 관광활성화와 지역경제발전에 <br />
                  기여함은 물론, 대한민국 국민의 여가, 관광,
                  <br /> 문화생활과 공익을 위해 노력할 뿐만아니라,
                  <br /> 외국 관광객의 한국방문을 적극유도할 수 있는
                  <br /> 시스템을 구축하고, 세계시장을 선도하는 업체로
                  <br /> 발전하고자 부단히 노력할 것을 다짐합니다.
                </Grid>
              </Grid>
              {/* <Grid>
                <img src="/images/bg_ceo_msg.png" alt={'img'} style={{ width: '100%' }} />
              </Grid> */}
            </Grid>
          </Grid>

          <Footer />
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(CeoIntro);
